//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCurrentProvider } from 'core/components/ad-controllers/providers'

export default {
    name: 'PrivacyPage',

    metaInfo() {
        return {
            title: 'Privacy Policy',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: "Privacy is a top priority for us, and we won't do anything with your information that we wouldn't want done with ours.",
            }],
        }
    },

    data() {
        return {
            provider: getCurrentProvider(),
            npCcpa: false,
            plCcpa: false,
        }
    },

    methods: {
        waitForNpCcpaLink() {
            const linkContainer = this.$refs.npCcpaLink
            const nestedSpan = linkContainer.querySelector('a > span')
            if (!nestedSpan) return

            nestedSpan.innerText = 'over here.'
            this.npCcpa = true
            clearInterval(this.npCcpaInterval)
        },

        waitForPlCcpaLink() {
            const linkContainer = this.$refs.plCcpaLink
            const nestedLink = linkContainer.querySelector('a')
            if (!nestedLink) return

            nestedLink.innerText = 'over here.'
            this.plCcpa = true
            clearInterval(this.plCcpaInterval)
        },
    },

    mounted() {
        if (this.provider?.id === 'np') {
            this.npCcpaInterval = setInterval(this.waitForNpCcpaLink, 50)
            if (window.__uspapi) window.__uspapi('addLink', 1)
        }

        if (this.provider?.id === 'pl') {
            this.plCcpaInterval = setInterval(this.waitForPlCcpaLink, 50)
        }
    },

    beforeDestroy() {
        clearInterval(this.npCcpaInterval)
        clearInterval(this.plCcpaInterval)
    },
}
